<div class="d-flex justify-content-center align-items-center my-3">
  <nav aria-label="Page navigation">
    <ul class="pagination pagination-rounded shadow-sm">

      <!-- Previous -->
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link text-primary fw-bold" (click)="prev()" aria-label="Previous">
          &laquo; {{"MENU.DASHBOARD.prev" | translate}}
        </a>
      </li>

      <!-- Page numbers -->
      <li
        class="page-item"
        *ngFor="let page of pages"
        [class.active]="page === currentPage"
      >
        <a
          class="page-link"
          (click)="goToPage(page)"
          [ngClass]="{ 'bg-primary text-white border-primary': page === currentPage }"
        >
          {{ page }}
        </a>
      </li>

      <!-- Next -->
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link text-primary fw-bold" (click)="next()" aria-label="Next"
            [ngClass]="{'rtl-next': isRtl}"
>
          {{"MENU.DASHBOARD.next" | translate}} &raquo;
        </a>
      </li> 

    </ul>
  </nav>
</div>




